// Module
var code = "<div class=\"row search-result default mx-2\"> <div class=\"col-12 col-lg-12 text-center\"> <h4>Uh oh! We couldn’t find any results.</h4> <p class=\"fs-6\"> </p><div id=\"search-error-msg\">Try browsing our experts by topic or <a href=\"#\">contact us</a> for help finding someone to speak to.</div> <p></p> </div> </div>";
// Exports
export default code;